import type { AuthUser } from '@/types'

export function getUserDisplayName(user?: AuthUser | null) {
  if (!user) return 'User'

  const fullName = [user.firstName, user.lastName]
    .filter(Boolean)
    .join(' ')
    .trim()

  if (fullName.length) return fullName
  return user.email || user.phoneNumber || 'User'
}

export function getUserInitials(user?: AuthUser | null) {
  if (!user) return 'U'

  const first = user.firstName?.[0]
  const last = user.lastName?.[0]

  if (first || last) {
    return `${first ?? ''}${last ?? ''}`.toUpperCase()
  }

  if (user.email?.length) return user.email.slice(0, 2).toUpperCase()
  if (user.phoneNumber?.length) return user.phoneNumber.slice(-2).toUpperCase()
  return 'U'
}
